import { render, staticRenderFns } from "./WorkplaceReservationPage.vue?vue&type=template&id=77e0acc8&scoped=true&"
import script from "./WorkplaceReservationPage.vue?vue&type=script&lang=js&"
export * from "./WorkplaceReservationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e0acc8",
  null
  
)

export default component.exports